import { DELETE } from './api-utils'
import { environments, getPrivateBaseUrls } from '../../common/environment-configs'

const STORE_CACHE_PATH = '/amiga/cache/itx.mecgemabkt.stores'

const clearCacheCall = async (baseUrl) => {
  if (baseUrl === undefined || baseUrl == null) {
    return
  }
  return await DELETE(baseUrl + STORE_CACHE_PATH).then((response) => {
    return response ? response.data : null
  })
}

export const clearCache = async (env, brand) => {
  if (env === environments.PRO_CN_CPD1) {
    clearCacheCall(getPrivateBaseUrls(environments.PRO_CN_CPD2)[brand])
  } else if (env === environments.PRO_CN_CPD2) {
    clearCacheCall(getPrivateBaseUrls(environments.PRO_CN_CPD1)[brand])
  }
}
